import styled from 'styled-components';
import { Divider, Form } from 'antd';
import { lightTheme } from '@/styles/themes/light';

const { fonts } = lightTheme;

const FormItem = Form.Item;

export const HandsPositionGrid = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 24px 40px;
	background-color: #f0f0f0;
	border-radius: 8px;

	@media (max-width: 1199px) {
		flex-wrap: wrap;
		justify-content: flex-start;
		gap: 16px;
	}
`;

export const HandsPositionImageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	height: auto;
	max-height: 85px;

	svg {
		max-height: 85px;
		width: auto;
	}

	@media (max-width: 1199px) {
		flex: 0 0 calc(33.33% - 11px);
	}
`;

export const HandsPositionCard = styled.div`
	border: 1px solid #d9d9d9;
	border-radius: 8px;
	padding: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 120px;
	height: 120px;
	background-color: #fafafa;
	flex-shrink: 0;

	&:hover {
		border-color: #5474d1;
		cursor: pointer;
	}
`;

export const RadioOptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	.ant-radio-wrapper {
		align-items: flex-start;
		padding: 8px;
		font-size: 16px;
	}
`;

export const HorizontalDivider = styled(Divider)`
	margin: 0;
`;

export const FormItemRow = styled(FormItem)`
	margin: 0;
`;

export const FactorDescriptionHeader = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
	font-weight: ${fonts.label.md.fontWeight} !important;
`;

export const FactorDescriptionText = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
`;